export default __webpack_public_path__ + "static/media/Killjoy_Nanoswarm.bc099d2d.png";